/*
 * @Description: 
 * @Author: huangshiwen
 * @Date: 2022-05-30 13:36:37
 * @LastEditTime: 2025-01-15 11:35:56
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import { routerMap } from './router.config'
Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: '/html/webpatient',
  routes: routerMap,
})
router.beforeEach((to, from, next) => {
  console.log(to, 'tttttttttttttt')
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  if(to.name=="login"&&to.hash=="#logout"){
    localStorage.clear()

    // localStorage.removeItem('userId')
    // localStorage.removeItem('ut')
  }
  else {
    next()
  }
  window.parent.postMessage(
    {
      type: 'changeRoute',
      url:to.fullPath,
    },
    '*'
  )

  // if(to.name=="login"&&to.hash=="#logout"){
  //   localStorage.clear()
  // }
  // window.parent.postMessage(
  //   {
  //     type: 'changeRoute',
  //     url:to.fullPath,
  //   },
  //   '*'
  // )
  // next()
})
export default router